module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-fab-transition', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dirty),
      expression: "dirty"
    }],
    attrs: {
      "loading": _vm.loading,
      "fab": "",
      "bottom": "",
      "left": "",
      "fixed": "",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("save", _vm.invoice)
      }
    }
  }, [_c('v-icon', [_vm._v("save")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "order-xs2": "",
      "order-sm1": ""
    }
  }, [(_vm.practitioner.logo_picture) ? _c('img', {
    staticClass: "mt-4 hidden-xs-only",
    staticStyle: {
      "max-height": "200px",
      "max-width": "400px"
    },
    attrs: {
      "src": _vm.practitioner.logo_picture
    }
  }) : _c('v-alert', {
    attrs: {
      "value": true,
      "type": "info"
    }
  }, [_vm._v("\n          Looks like you haven't updated a logo.\n          "), (_vm.spaceSettings) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": "",
      "href": _vm.spaceSettings,
      "disabled": !_vm.rolesIsOwnerOfSpace(_vm.spaceId),
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list', [(_vm.practitioner.practice_name || _vm.practitioner.practice_number) ? _c('v-subheader', {
    staticClass: "ml-0 pl-0 pb-0"
  }, [_vm._v("Business details:")]) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [(_vm.practitioner.practice_name) ? _c('v-list-tile-title', [_c('strong', [(_vm.practitioner.practice_number) ? _c('span', [_vm._v("Practice")]) : _c('span', [_vm._v("Business")]), _vm._v("\n                  name:\n                ")]), _vm._v("\n                " + _vm._s(_vm.practitioner.practice_name) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.practitioner.practice_number) ? _c('v-list-tile-sub-title', [_c('strong', [_vm._v("Practice number:")]), _vm._v("\n                " + _vm._s(_vm.practitioner.practice_number) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.spaceSettings) ? _c('v-btn', {
    attrs: {
      "href": _vm.spaceSettings,
      "disabled": !_vm.rolesIsOwnerOfSpace(_vm.spaceId),
      "target": "_blank",
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "order-xs1": "",
      "order-sm2": ""
    }
  }, [_c('date-picker-dialog', {
    attrs: {
      "close-on-change": "",
      "label": "Invoice date"
    },
    model: {
      value: (_vm.invoice.date),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "date", $$v)
      },
      expression: "invoice.date"
    }
  }), _vm._v(" "), _c('date-picker-dialog', {
    attrs: {
      "close-on-change": "",
      "label": "Due date"
    },
    model: {
      value: (_vm.invoice.due_date),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "due_date", $$v)
      },
      expression: "invoice.due_date"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "order-xs3": "",
      "order-sm3": ""
    }
  }, [_c('v-subheader', {
    staticClass: "ml-0 pl-0 pb-0"
  }, [_vm._v("Invoiced by:")]), _vm._v(" "), _c('v-textarea', {
    staticClass: "mb-0",
    attrs: {
      "box": "",
      "auto-grow": "",
      "persistent-hint": true,
      "hint": "Editing this value will only change the details for this invoice. To update the billing address for new invoices, click \"Edit billing address\""
    },
    model: {
      value: (_vm.invoice.billing_address),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "billing_address", $$v)
      },
      expression: "invoice.billing_address"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "order-xs4": "",
      "order-sm4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "ml-0 pl-0 pb-0"
  }, [_vm._v("Customer details:")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "box": "",
      "auto-grow": ""
    },
    model: {
      value: (_vm.invoice.invoicee_details),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "invoicee_details", $$v)
      },
      expression: "invoice.invoicee_details"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Include medical aid details"
    },
    model: {
      value: (_vm.invoice.integrate_medical_aid),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "integrate_medical_aid", $$v)
      },
      expression: "invoice.integrate_medical_aid"
    }
  }), _vm._v(" "), (_vm.invoice.integrate_medical_aid) ? _c('v-textarea', {
    attrs: {
      "box": "",
      "label": "Medical aid details:"
    },
    model: {
      value: (_vm.invoice.medicalaid_details),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "medicalaid_details", $$v)
      },
      expression: "invoice.medicalaid_details"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "mb-2 mt-4",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.enriching,
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.enrich(_vm.invoice.appointments)
      }
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Lineitems")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _vm._l((_vm.invoice.appointment_data), function(appointment) {
    return [_c('v-card', {
      key: appointment.id,
      staticClass: "mt-2"
    }, [_c('v-layout', {
      staticClass: "pa-1",
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      staticClass: "pt-3 pl-2 subheading",
      attrs: {
        "xs3": ""
      }
    }, [_vm._v(_vm._s(appointment.invoice_title || appointment.title || appointment.full_name))]), _vm._v(" "), _c('v-flex', {
      staticClass: "pt-3",
      attrs: {
        "xs3": ""
      }
    }, [_vm._v(_vm._s(_vm.dateformat(appointment.start_time)))]), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-right pt-3",
      attrs: {
        "xs3": ""
      }
    }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.invoice.currency, appointment.price)) + "\n        ")]), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-right",
      attrs: {
        "xs3": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.openGlobalDialog(true, 'InvoiceDetails', {
            appointment: appointment,
            touch: Math.random()
          })
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: appointment.start_time
    }), _vm._v(" "), (appointment.codes && appointment.codes.length > 0) ? _c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('h3', {
      key: appointment.end_time,
      staticClass: "subheading ml-3 mt-2"
    }, [_vm._v("Sub-items")]), _vm._v(" "), _vm._l((appointment.codes), function(code) {
      return [_c('v-layout', {
        key: code.id,
        attrs: {
          "row": ""
        }
      }, [_c('v-divider', {
        key: code.process_code
      }), _vm._v(" "), _c('v-flex', {
        staticClass: "pt-3 pl-4",
        attrs: {
          "xs3": ""
        }
      }, [_vm._v(_vm._s(code.icd10))]), _vm._v(" "), _c('v-flex', {
        staticClass: "pt-3",
        attrs: {
          "xs3": ""
        }
      }, [_vm._v(_vm._s(code.process))]), _vm._v(" "), _c('v-flex', {
        staticClass: "text-xs-right pt-3",
        attrs: {
          "xs3": ""
        }
      }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.invoice.currency, code.price)) + "\n            ")]), _vm._v(" "), _c('v-flex', {
        staticClass: "text-xs-right",
        attrs: {
          "xs3": ""
        }
      }, [_vm._v("\n               \n              ")])], 1), _vm._v(" "), _c('v-divider', {
        key: code.process
      })]
    })], 2) : _vm._e()], 1)]
  }), _vm._v(" "), _c('v-card-actions', [_c('v-icon', [_vm._v("info")]), _vm._v("\n        Appointments are saved on the invoice when created.\n        To update the appointments as they appear on this invoice\n        you will need to\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "loading": _vm.enriching,
      "icon": _vm.$vuetify.breakpoint.xs
    },
    on: {
      "click": function($event) {
        return _vm.enrich(_vm.invoice.appointments)
      }
    }
  }, [_c('v-icon', [_vm._v("replay")]), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs-only"
  }, [_vm._v("Refresh Appointments")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-subheader', {
    staticClass: "ml-0 pl-0 pb-0"
  }, [_vm._v("Notes:")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "box": ""
    },
    model: {
      value: (_vm.invoice.notes),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "notes", $$v)
      },
      expression: "invoice.notes"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-subheader', {
    staticClass: "ml-0 pl-0 pb-0"
  }, [_vm._v("Banking details:")]), _vm._v(" "), _c('v-textarea', {
    staticClass: "mb-0 pb-0",
    attrs: {
      "box": ""
    },
    model: {
      value: (_vm.invoice.banking_details),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "banking_details", $$v)
      },
      expression: "invoice.banking_details"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "small": "",
      "flat": "",
      "to": "/settings/profile"
    }
  }, [_vm._v("Edit banking details")])], 1)], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06c9a44d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/InvoiceDetail.vue
// module id = 1317
// module chunks = 9